import { render, staticRenderFns } from "./DoubleCheckIcon.vue?vue&type=template&id=be7136bc&scoped=true&"
import script from "./DoubleCheckIcon.vue?vue&type=script&lang=js&"
export * from "./DoubleCheckIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be7136bc",
  null
  
)

export default component.exports